// @flow
import Row from './Row'
import Ref from 'components/References/Ref'

type Props = {
  daysSinceLastAnnualFee: number,
}

const AnnualFeeRef = (props: Props) => {
  const { daysSinceLastAnnualFee } = props

  const getDaysDisplay = () => {
    if (daysSinceLastAnnualFee === null || daysSinceLastAnnualFee === undefined) {
      return 'Not Available'
    }
    return `${daysSinceLastAnnualFee} days`
  }

  const getStatusColor = () => {
    if (daysSinceLastAnnualFee === null || daysSinceLastAnnualFee === undefined) {
      return {}
    }

    if (daysSinceLastAnnualFee <= 90) {
      return { color: 'red' }
    }
    return {}
  }

  return (
    <Ref
      title="Annual Fee"
      preview={
        <div>
          <Row singleLine label="Days Since Last Fee" val={<span style={getStatusColor()}>{getDaysDisplay()}</span>} mono={true} />
        </div>
      }
    />
  )
}

export default AnnualFeeRef
